import api from "../../database";

export interface IContact {
  name: string;
  avatar: string;
  code: number;
}

export const searchContact = async (
  code: number,
  token: string,
): Promise<IContact> => {
  const response = await api.get("/contacts/search", {
    params: { code },
    headers: { "x-access-token": token },
  });
  return response.data?.searchUser;
};

// Adiciona ou remove um contato pelo código e devolve a lista atualizada
export const updateContact = async (
  code: number,
  action: "add" | "remove",
  token: string,
): Promise<IContact[]> => {
  const response = await api.patch(
    "/contacts",
    { contactId: code, action },
    { headers: { "x-access-token": token } },
  );
  return response.data?.contacts ?? [];
};
